import React, { useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  ListItemText,
  ListItem,
  List
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

const ServicesStep = ({ formData, updateFormData, setIsValid, errors, setErrors, servicesByType }) => {

  const licenseInputRef = useRef(null);
  const certificateInputRef = useRef(null);

  // Boolean fields from formData mapped to service names
  const servicesMapping = {
    "Mortgage Pre-Approval": "mortgage_pre_approval",
    "First-Time Home Buyer Loans": "first_time_home_buyer_loans",
    "Refinancing Services": "refinancing_services",
    "Investment Property Loans": "investment_property_loans",
    "Debt Consolidation": "debt_consolidation",
    "Interest Rate Optimization": "interest_rate_optimization",
    "Loan Application Assistance": "loan_application_assistance",
    "Credit Score Consultation": "credit_score_consultation",
    "Reverse Mortgages": "reverse_mortgages",
    "Home Equity Loans": "home_equity_loans",
    "Custom Loan Solutions": "custom_loan_solutions",
    "Construction Loans": "construction_loans",
    "Government-Backed Loans": "government_backed_loans"
  };

  console.log('servicesByType', {servicesByType,servicesMapping })

  const handleServiceChange = (service) => {
    console.log('service', service)
    const field = servicesMapping[service];  // get the field name from the mapping
    const newValue = !formData[field];  // toggle the boolean value
    // Update the formData state
    updateFormData(field, newValue);
  };

  // const handleServiceChange1 = (serviceName) => {
  //   updateFormData((prev) => {
  //     const updatedServices = prev.services?.includes(serviceName)
  //       ? prev.services.filter((s) => s !== serviceName) // remove
  //       : [...(prev.services || []), serviceName];       // add
  
  //     return {
  //       ...prev,
  //       services: updatedServices,
  //     };
  //   });
  // };

  const handleServiceChange1 = (serviceDetails) => {

    console.log('serviceDetails', {serviceDetails})
    
    const currentServices = formData.services || [];
  
    const updatedServices = currentServices.includes(serviceDetails?._id)
      ? currentServices.filter((s) => s !== serviceDetails?._id) 
      : [...currentServices, serviceDetails?._id]; 

    console.log("DEBUG: Updating services to ->", updatedServices);

  
    updateFormData("services", updatedServices);
  };
  
  
  useEffect(() => {
    // Set validation state based on current errors
    const isValid = Object.values(errors).every((error) => error === "");
    setIsValid(isValid); // Pass validation status back to parent
  }, [errors]);

  const isGenericEmail = (email) => {
    const genericDomains = [
      'gmail.com',
      'yahoo.com',
      'hotmail.com',
      'outlook.com',
      'aol.com',
      'icloud.com',
    ];
    const domain = email.split('@')[1];
    return genericDomains.includes(domain);
  };

  const validateField = (name, value) => {
    let errorMessage = "";

    switch (name) {
      case "website":
        if (!value.trim()) {
          // errorMessage = "Website is required";
        } else if (!/^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[^\s]*)?$/.test(value)) {
          errorMessage = "Invalid website URL";
        }
        break;

      case "work_email":
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!value.trim()) {
          errorMessage = "Work email is required";
        } else if (!emailRegex.test(value)) {
          errorMessage = "Please enter a valid email address";
        } else if (isGenericEmail(value)) { // Call the isGenericEmail function here.
          errorMessage = "Please use a business email address";
        }
        break;

      case "linkedin":
        if (!value.trim()) {
          // } else if (!/^https?:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+$/.test(value)) {
        } else if (!/^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[^\s]*)?$/.test(value)) {
          errorMessage = "Invalid LinkedIn URL";
        }
        break;

      case "professional_title":
        if (!value.trim()) {
          errorMessage = "Professional title is required";
        }
        break;

      case "certifications_affiliations":
        if (!value.trim()) {
          errorMessage = "Certifications or affiliations are required";
        }
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));

    return errorMessage;
  };


  const handleTextFieldChange = (e) => {
    const { name, value } = e.target;
    updateFormData(name, value);
    validateField(name, value);
  };

  const removeFile = (name, index) => {
    const updatedFiles = formData[name].filter((_, i) => i !== index);
    updateFormData(name, updatedFiles);

    // Reset the file input if no files left
    if (updatedFiles.length === 0) {
      if (name === "licenses" && licenseInputRef.current) {
        licenseInputRef.current.value = '';
      }
      if (name === "certificates" && certificateInputRef.current) {
        certificateInputRef.current.value = '';
      }
    }
  };

  console.log('formData', {fd:formData[servicesMapping], formData})


  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Services Provided <span style={{ color: 'red' }}>*</span>
        </Typography>
        <FormGroup>
          <Grid container spacing={2}>
            {/* {Object.keys(servicesMapping).map((service) => (
              <Grid item xs={12} sm={6} md={4} key={service}>
                <FormControlLabel
                  control={
                    <Checkbox
                    checked={formData.services?.includes(item.servicesName)}
                    onChange={() => handleServiceChange(item.servicesName)}
                      color="primary"
                      sx={{
                        '&.Mui-checked': {
                          color: 'green',
                        },
                      }}
                    />
                  }
                  label={service}
                />
              </Grid>
            ))} */}
        {servicesByType.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item._id}>
            <FormControlLabel
              control={
                <Checkbox
                checked={formData.services?.includes(item._id)}
                onChange={() => handleServiceChange1(item)}
                  color="primary"
                  sx={{
                    '&.Mui-checked': {
                      color: 'green',
                    },
                  }}
                />
              }
              label={item.servicesName}
            />
          </Grid>
        ))}

          </Grid>
        </FormGroup>
        {errors.services && (<Typography variant="body2" color="error" sx={{ fontWeight: 400, marginTop: 1 }}>{errors.services}</Typography>)}
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          Attach External Links
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              Website
            </Typography>
            <TextField
              fullWidth
              name="website"
              value={formData.website}
              onChange={handleTextFieldChange}
              placeholder="www.yourdomain.com"
              variant="outlined"
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                }
              }}
            />
            {errors.website && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.website}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              Work Email <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="work_email"
              value={formData?.work_email}
              onChange={handleTextFieldChange}
              placeholder="your.name@company.com"
              variant="outlined"
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                }
              }}
            />
            {errors.work_email && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.work_email}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              LinkedIn
            </Typography>
            <TextField
              fullWidth
              name="linkedin"
              value={formData.linkedin}
              onChange={handleTextFieldChange}
              placeholder="https://www.linkedin.com/in/yourprofile"
              variant="outlined"
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                }
              }}
            />
            {errors.linkedin && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.linkedin}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              Certifications & Affiliations <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="certifications_affiliations"
              value={formData?.certifications_affiliations}
              onChange={handleTextFieldChange}
              placeholder="List your professional certifications and affiliations"
              variant="outlined"
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                }
              }}
            />
            {errors.certifications_affiliations && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.certifications_affiliations}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              Upload Licenses <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              type="file"
              inputProps={{
                multiple: true,
                accept: '.pdf, .png, .jpg, .jpeg',
              }}
              name="license_file"
              inputRef={licenseInputRef}
              onChange={(e) => updateFormData("licenses", e.target.files)}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                },
                '& input': { padding: '10px' },
              }}
            />

            {/* Info Label */}
            <Typography
              variant="body2"
              sx={{ fontStyle: 'italic', mt: 0.5, color: '#666' }}
            >
              Max 5 files can be uploaded and total size should not exceed 10 MB.
            </Typography>

            {/* Preview Licenses */}
            {Array.isArray(formData.licenses) && formData.licenses.length > 0 && (
              <Box
                sx={{
                  maxHeight: '100px',
                  overflowY: 'auto',
                  mt: 1,
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  p: 1,
                }}
              >
                <List dense>
                  {formData.licenses.map((file, i) => (
                    <ListItem
                      key={i}
                      secondaryAction={
                        <IconButton edge="end" aria-label="remove" onClick={() => removeFile('licenses', i)}>
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={file.name} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            {errors.licenses && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.licenses}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" gutterBottom>
              Upload Certificates <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              type="file"
              inputProps={{
                multiple: true,
                accept: '.pdf, .png, .jpg, .jpeg',
              }}
              inputRef={certificateInputRef}
              name="certificates_file"
              onChange={(e) => updateFormData("certificates", e.target.files)}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={{
                backgroundColor: 'rgba(211, 211, 211, 0.15)',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(211, 211, 211, 0.19)',
                  borderRadius: '12px',
                },
                '& input': { padding: '10px' },
              }}
            />

            {/* Info Label */}
            <Typography
              variant="body2"
              sx={{ fontStyle: 'italic', mt: 0.5, color: '#666' }}
            >
              Max 5 files can be uploaded and total size should not exceed 10 MB.
            </Typography>

            {/* Preview Certificates */}
            {Array.isArray(formData.certificates) && formData.certificates.length > 0 && (
              <Box
                sx={{
                  maxHeight: '100px',
                  overflowY: 'auto',
                  mt: 1,
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  p: 1,
                }}
              >
                <List dense>
                  {formData.certificates.map((file, index) => (
                    <ListItem
                      key={index}
                      secondaryAction={
                        <IconButton edge="end" aria-label="remove" onClick={() => removeFile('certificates', index)}>
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={file.name} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            {errors.certificates && (
              <Typography
                variant="body2"
                color="error"
                sx={{ fontWeight: 400, marginTop: 1 }}
              >
                {errors.certificates}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ServicesStep;
